(() => {
  if (window.ptEditableReady) return;
  window.ptEditableReady = true;
  const states = new WeakMap();
  function init(root) {
    if (states.has(root)) return;
    const state = { controller: new AbortController(), timer: null };
    states.set(root, state);
    const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: state.controller.signal });
    const header = root.querySelector('.brandbar');
    const menuToggle = root.querySelector('.pt-menu-toggle');
    if (header && menuToggle) {
      const closeMenu = () => {
        header.classList.remove('is-menu-open');
        header.querySelectorAll('.pt-tea-menu').forEach(menu=>menu.open=false);
        menuToggle.setAttribute('aria-expanded','false');
        menuToggle.setAttribute('aria-label','Open menu');
      };
      on(menuToggle,'click',()=>{
        const open = menuToggle.getAttribute('aria-expanded') !== 'true';
        header.classList.toggle('is-menu-open',open);
        menuToggle.setAttribute('aria-expanded',String(open));
        menuToggle.setAttribute('aria-label',open?'Close menu':'Open menu');
      });
      root.querySelectorAll('.pt-mini-menu a').forEach(link=>on(link,'click',closeMenu));
      on(document,'click',e=>{if(!header.contains(e.target)) closeMenu();});
      on(header,'keydown',e=>{if(e.key==='Escape'){const activeMenu=header.querySelector('.pt-tea-menu[open]');if(activeMenu){activeMenu.open=false;activeMenu.querySelector('summary').focus();}else if(menuToggle.getAttribute('aria-expanded')==='true'){closeMenu();menuToggle.focus();}}});
      on(header,'focusout',e=>{if(!header.contains(e.relatedTarget)) closeMenu();});
    }
    const form = root.querySelector('form.pt-bundles');
    if (form) {
      const radios = [...form.querySelectorAll('input[type=radio][name=id]')];
      const button = form.querySelector('[data-bundle-add]');
      const error = form.querySelector('[data-cart-error]');
      let busy = false;
      const selected = () => radios.find(r=>r.checked);
      const update = () => {
        const pack = selected();
        if (!pack) { button.disabled=true; return; }
        form.querySelector('[data-bundle-total]').textContent=pack.dataset.formattedPrice;
        button.disabled=busy || pack.dataset.available!=='true';
        button.textContent=busy?'ADDING…':pack.dataset.available==='true'?button.dataset.label:'CURRENTLY UNAVAILABLE';
        error.hidden=true;
      };
      radios.forEach(r=>on(r,'change',update));
      on(form,'submit',async e=>{
        e.preventDefault();
        const pack=selected();
        if(busy || !pack || pack.dataset.available!=='true') return;
        busy=true; update(); form.setAttribute('aria-busy','true');
        radios.forEach(r=>{r.disabled=true;});
        try {
          const response=await fetch(form.action.replace(/\/$/,'')+'.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(pack.value),quantity:1}]}),credentials:'same-origin'
          });
          const result=await response.json();
          if(!response.ok || result.status) throw new Error(typeof result.description==='string'?result.description:'Unable to add this pack. Please try again.');
          window.location.assign(form.dataset.cartUrl);
        } catch(err) {
          busy=false;radios.forEach(r=>{r.disabled=false;});update();form.removeAttribute('aria-busy');
          error.textContent=err.message || 'Please check your connection and try again.';error.hidden=false;
        }
      });
      update();
    }
    const hero = root.querySelector('.pt-hero-image');
    const thumbs = [...root.querySelectorAll('.thumb')];
    let active = 0;
    function show(index) {
      if (!hero || !thumbs.length) return;
      active = (index + thumbs.length) % thumbs.length;
      const img = thumbs[active].querySelector('img');
      if (!img) return;
      hero.src = img.currentSrc || img.src;
      hero.alt = img.alt;
      hero.style.objectPosition = img.style.objectPosition;
      thumbs.forEach((t,i) => t.setAttribute('aria-current', String(i === active)));
    }
    state.show = show;
    show(0);
    on(root.querySelector('.gallery-arrow.prev'), 'click', () => show(active - 1));
    on(root.querySelector('.gallery-arrow.next'), 'click', () => show(active + 1));
    thumbs.forEach((t,i) => on(t, 'click', () => show(i)));
    if (hero && !thumbs.length) root.querySelectorAll('.gallery-arrow').forEach(el => {el.hidden = true;});
    root.querySelectorAll('.jump-offer').forEach(link => on(link, 'click', e => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      let target;
      try { const hash = decodeURIComponent(url.hash.slice(1)); target = document.getElementById(hash); const section = {"pt-product":"3","pt-reviews":"14","pt-faq":"15"}[hash]; if (!target && section) target = document.querySelector('[data-section="' + section + '"]'); } catch { return; }
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block:'start'});
    }));
    root.querySelectorAll('.video-card').forEach(card => {
      const video = card.querySelector('video');
      if (!video) return;
      video.controls = true;
      on(card.querySelector('.video-play'), 'click', async () => {
        try { await video.play(); card.classList.add('playing'); } catch { video.controls = true; }
      });
      on(video, 'pause', () => card.classList.remove('playing'));
      on(video, 'ended', () => card.classList.remove('playing'));
    });
    const messages = [...root.querySelectorAll('.topbar-track > span')];
    const duration = Number(root.dataset.rotation) * 1000;
    if (messages.length > 1 && duration > 0 && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      let current = 0;
      const reveal = i => messages.forEach((m,j) => { m.hidden = j !== i; });
      reveal(0);
      state.reveal = reveal;
      state.timer = setInterval(() => { current = (current + 1) % messages.length; reveal(current); }, duration);
    }
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-pt-section]')) init(scope);
    scope.querySelectorAll('[data-pt-section]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once:true});
  else scan();
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-pt-section]').forEach(root => {
      const state = states.get(root);
      if (state) { clearInterval(state.timer); state.controller.abort(); states.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest('[data-pt-section]');
    if (!root) return;
    const state = states.get(root);
    if (e.target.matches('details')) e.target.open = true;
    const thumb = e.target.closest('.thumb');
    if (thumb) state?.show([...root.querySelectorAll('.thumb')].indexOf(thumb));
    if (e.target.matches('.topbar-track > span')) {
      clearInterval(state?.timer);
      state?.reveal?.([...root.querySelectorAll('.topbar-track > span')].indexOf(e.target));
    }
  });
})();
